import "./bootstrap";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import filters from "./filters";
import vuetify from "./plugins/vuetify";

//axios global
axios.defaults.baseURL = window._asset;

// vue toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options = {
    position: "top-right",
};
// casl
import { abilitiesPlugin } from "@casl/vue";
import ability from "./plugins/casl/ability";

//pinia
import { createPinia } from "pinia";
const pinia = createPinia();

//sweetalert2
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const optionsSwal = {
    // confirmButtonColor: '#00A2EA',
    // cancelButtonColor: '#5f5f5f',
    confirmButtonText: "Konfirmasi",
    cancelButtonText: "Batal",
};

import VueDragscroll from "vue-dragscroll";
import Camera from "simple-vue-camera";

// perfect scrollbar
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/style.css";

// apexchart
import VueApexCharts from "vue3-apexcharts";

//picture viewer
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
VueViewer.setDefaults({
    navbar: false,
    title: false,
    toolbar: false,
});

// import JsonExcel from "vue-json-excel3";

const app = createApp(App);

//component
app.component("camera", Camera);
// app.component("export-excel", JsonExcel);

app.use(VueDragscroll);
app.use(VueViewer);
app.use(VueSweetalert2, optionsSwal);
app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
});
app.use(PerfectScrollbarPlugin);
app.use(VueApexCharts);
app.use(Toast, options);
app.use(router);
app.use(vuetify);
app.use(pinia);

app.config.globalProperties.$filters = filters;
// app.config.globalProperties.$asset = (path) => {
//     var base_path = window._asset || '';
//     let link = path ? path : '';
//     return base_path + link ;
// }
app.mount("#app");
